"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotecardScratchpadPlacement = exports.NotecardSetMode = exports.NextNotecardMode = exports.ReferralSource = exports.ACCESS_TYPE_TO_PRETTY_NAME = exports.ALL_ACCESS_TYPES = exports.AccessType = void 0;
var AccessType;
(function (AccessType) {
    AccessType["OUTLINES"] = "OUTLINES";
    AccessType["NOTECARDS"] = "NOTECARDS";
    AccessType["PRACTICE_PROBLEMS"] = "PRACTICE_PROBLEMS";
})(AccessType || (exports.AccessType = AccessType = {}));
exports.ALL_ACCESS_TYPES = [
    AccessType.OUTLINES,
    AccessType.NOTECARDS,
    AccessType.PRACTICE_PROBLEMS,
];
exports.ACCESS_TYPE_TO_PRETTY_NAME = {
    [AccessType.OUTLINES]: 'OUTLINES',
    [AccessType.NOTECARDS]: 'NOTECARDS',
    [AccessType.PRACTICE_PROBLEMS]: 'PRACTICE QUESTIONS',
};
var ReferralSource;
(function (ReferralSource) {
    ReferralSource["REDDIT"] = "Reddit";
    ReferralSource["DISCORD"] = "Discord";
    ReferralSource["GOOGLE"] = "Google";
    ReferralSource["FRIEND_COWORKER"] = "Friend/Coworker";
    ReferralSource["COMPANY_POSTING"] = "Company Posting";
    ReferralSource["THIRD_PARTY_SITE"] = "Third Party Site";
    ReferralSource["SOA_CONFERENCE"] = "SoA Conference";
    ReferralSource["OTHER"] = "Other";
    ReferralSource["UNIVERSITY"] = "University";
})(ReferralSource || (exports.ReferralSource = ReferralSource = {}));
var NextNotecardMode;
(function (NextNotecardMode) {
    NextNotecardMode["spacedRepetition"] = "Spaced Repetition";
    NextNotecardMode["inCanonicalOrder"] = "Content Order";
})(NextNotecardMode || (exports.NextNotecardMode = NextNotecardMode = {}));
var NotecardSetMode;
(function (NotecardSetMode) {
    NotecardSetMode["normal"] = "normal";
    NotecardSetMode["reverse"] = "reverse";
})(NotecardSetMode || (exports.NotecardSetMode = NotecardSetMode = {}));
var NotecardScratchpadPlacement;
(function (NotecardScratchpadPlacement) {
    NotecardScratchpadPlacement["top"] = "top";
    NotecardScratchpadPlacement["bottom"] = "bottom";
})(NotecardScratchpadPlacement || (exports.NotecardScratchpadPlacement = NotecardScratchpadPlacement = {}));
//# sourceMappingURL=types.js.map